import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { RmComponentsCredentialsInputDTORuntype, RmComponentsResponseBodyDTORuntype } from './rmComponentsBackendTypes';

export const rmComponentsEndpoints = {
    'GET /3rdparty/rmcomponents/credentials': endpoint({
        description: 'Returns credentials for RmComponents integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: RmComponentsResponseBodyDTORuntype,
    }),
    'POST /3rdparty/rmcomponents/credentials': endpoint({
        description: 'Uploads credentials for RmComponents API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: RmComponentsCredentialsInputDTORuntype,
        responseBody: RmComponentsResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/rmcomponents/credentials'],
    }),
    'PATCH /3rdparty/rmcomponents/credentials': endpoint({
        description: 'Updates credentials for RmComponents API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: RmComponentsCredentialsInputDTORuntype,
        responseBody: RmComponentsResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/rmcomponents/credentials'],
    }),
    'DELETE /3rdparty/rmcomponents/credentials': endpoint({
        description: 'Deletes existing credentials for RmComponents API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/rmcomponents/credentials'],
    }),
};
